import { useState } from "react";
import { AiOutlineMail, AiOutlineLock } from "react-icons/ai";
import { GALLERY } from "../../lib/routes";
import { useLogin } from "../../hooks/auth";
import { emailValidate, passwordValidate } from "../../utils/form-validate";

export default function Login() {
  // const [isLoading, setLoading] = useState(false);

  const { login, isLoginLoading } = useLogin();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: null, password: null });

  async function handleSignIn(e) {
    e.preventDefault();

    const emailError = validateField("email", email, emailValidate);
    const passwordError = validateField("password", password, passwordValidate);

    if (emailError || passwordError) {
      setErrors({
        email: emailError,
        password: passwordError,
      });

      setTimeout(() => {
        setErrors({ email: null, password: null });
      }, 3000);

      return;
    }

    // setLoading(true);

    const success = await login({
      email: email,
      password: password,
      redirectTo: GALLERY,
    });

    if (success) {
      setEmail("");
      setPassword("");
      setErrors({ email: null, password: null });
    }
    // setLoading(false);
  }

  const validateField = (fieldName, value, validationRules) => {
    let error = "";

    for (const rule in validationRules) {
      if (validationRules.hasOwnProperty(rule)) {
        const ruleValue = validationRules[rule];
        if (rule === "required" && ruleValue.value && !value) {
          error = ruleValue.message;
        } else if (rule === "minLength" && value.length < ruleValue.value) {
          error = ruleValue.message;
        } else if (rule === "pattern" && !ruleValue.value.test(value)) {
          error = ruleValue.message;
        }
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error,
    }));

    return error;
  };

  return (
    
    <div className="w-full h-screen flex flex-col items-center justify-center bg-gradient-to-b from-slate-800  to-stone-950">
      <div className="w-[80%] lg:w-[30%] rounded-xl shadow-2xl border border-gray-700 bg-gradient-to-b from-slate-800  to-stone-950 flex flex-col items-center pt-8 pb-8 pl-2 pr-2">
        <div className=" font-rale font-5xl font-bold  text-gray-400 text-center">
          Welcome to <span className="text-white">Drag</span>  n' <span className="text-white" > Drop</span> Gallery!
        </div>
        <hr className="border border-gray-500" />
        <p className="text-para text-center text-sm text-white mt-7">
          Enter your credentials to access your account.
        </p>

        <form onSubmit={handleSignIn} className="mt-8 min-w-[95%] ">
          <div className="relative">
            <input
              type="text"
              placeholder="test: user@example.com"
              className={`block ${
                errors.email === null ? "mb-4" : "mb-0"
              } pt-2 pb-2 pr-8 pl-2 w-full rounded-md border-2 border-base focus:outline-none focus:ring focus:border-light placeholder:text-gray-500`}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <AiOutlineMail className="text-gray-500" />
            </span>
          </div>

          {errors.email !== null && (
            <div className="mt-1 text-small text-center mb-4 text-red-500">
              {errors.email}
            </div>
          )}


          <div
            className={`
                        relative ${errors.password === null ? "mb-8" : "mb-0"}
                    `}
          >
            <input
              type="password"
              placeholder="test: 1Password"
              className="block pt-2 pb-2 pr-8 pl-2 w-full rounded-md border-2 border-base focus:outline-none focus:ring focus:border-light placeholder:text-gray-500"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <AiOutlineLock className="text-gray-500" />
            </span>
          </div>

          {errors.password !== null && (
            <div className="mt-1 text-small text-center mb-4 text-red-500">
              {errors.password}
            </div>
          )}

          <button
            className={`w-full ${
              isLoginLoading ? "opacity-50" : "opacity-100"
            } bg-gray-500 text-white rounded-md pt-2 pb-2 mb-8 relative`}
            disabled={isLoginLoading ? true : false}
          >
            {isLoginLoading ? (
              <div className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.963 7.963 0 014 12H0c0 3.042 1.135 5.842 3 7.938l3-2.647zM20 12a8 8 0 01-8 8v-4a4 4 0 004-4h4zm-2-5.291l3 2.647A7.963 7.963 0 0120 12h4c0-3.042-1.135-5.842-3-7.938z"
                  ></path>
                </svg>
                Processing...
              </div>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}